/* Hello couleur — filtres collection collapsible mobile.
   Sur mobile (≤900 px), affiche un bouton "Filtrer" qui plie/déplie la sidebar.
   Sur desktop ne fait rien (sidebar reste sticky/déployée).
   Port verbatim de mockups/shared/filters-mobile.js. */
(function () {
  var filters = document.querySelector('.filters');
  if (!filters) return;

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'filters__mobile-toggle';
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-controls', 'filters-content');
  btn.innerHTML = '<span>Filtrer</span><span class="filters__mobile-toggle-icon" aria-hidden="true">▾</span>';
  filters.insertBefore(btn, filters.firstChild);

  var content = document.createElement('div');
  content.className = 'filters__content';
  content.id = 'filters-content';

  // Ajout 2026-08-09 : un groupe qui contient des LIENS n'est pas un filtre,
  // c'est la navigation par categorie. Sur mobile elle doit rester visible :
  // la replier derriere un bouton "Filtrer" la rendait introuvable, alors que
  // c'est justement ce qui evite de faire defiler 69 produits.
  // Seuls les vrais filtres (prix, disponibilite, cases a cocher) sont replies.
  var enfants = Array.prototype.slice.call(filters.children);
  var navGroupes = [];
  var filtresGroupes = [];
  enfants.forEach(function (el) {
    if (el === btn) return;
    if (el.querySelector && el.querySelector('a.filter-link')) {
      navGroupes.push(el);
    } else {
      filtresGroupes.push(el);
    }
  });

  // appendChild deplace : l'ordre final est navigation, bouton, filtres replies.
  navGroupes.forEach(function (el) {
    el.classList.add('filter-group--nav');
    filters.appendChild(el);
  });
  filters.appendChild(btn);
  filtresGroupes.forEach(function (el) { content.appendChild(el); });
  filters.appendChild(content);

  // 2026-10-01 (Olivier) : sur téléphone (≤ 749 px), la navigation Type est AUSSI repliée dans le panneau,
  // pour que les produits apparaissent dès le premier écran. Tablette (750-900) et ordinateur : inchangé.
  var mqTel = window.matchMedia('(max-width: 749px)');
  var placerNav = function () {
    var i;
    if (mqTel.matches) {
      for (i = navGroupes.length - 1; i >= 0; i--) content.insertBefore(navGroupes[i], content.firstChild);
    } else {
      for (i = 0; i < navGroupes.length; i++) filters.insertBefore(navGroupes[i], btn);
    }
  };

  var mq = window.matchMedia('(max-width: 900px)');
  var apply = function () {
    placerNav();
    // Plus rien a replier (ex. tablette sans vrai filtre) : pas de bouton.
    if (mq.matches && content.children.length) {
      btn.style.display = 'flex';
      if (btn.getAttribute('aria-expanded') !== 'true') {
        content.style.display = 'none';
      }
    } else {
      btn.style.display = 'none';
      content.style.display = '';
      btn.setAttribute('aria-expanded', 'false');
      btn.classList.remove('open');
    }
  };
  apply();
  if (mq.addEventListener) { mq.addEventListener('change', apply); mqTel.addEventListener('change', apply); } else { mq.addListener(apply); mqTel.addListener(apply); }

  btn.addEventListener('click', function () {
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    content.style.display = open ? 'none' : '';
    btn.classList.toggle('open', !open);
  });
})();
